import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_result",
  "use": "icon-icon_result-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_result\">\r\n<path d=\"M4 13.5V5C4 3.89543 4.89543 3 6 3H14C15.1046 3 16 3.89543 16 5V13.5H10H4ZM4 13.5V15\" stroke=\"#0E419D\" stroke-width=\"1.5\" />\r\n<path d=\"M15.5 13.5H5.75C4.7835 13.5 4 14.2835 4 15.25V15.25C4 16.2165 4.7835 17 5.75 17H16.5\" stroke=\"#0E419D\" stroke-width=\"1.5\" />\r\n<path d=\"M7.5 6.5H12.5\" stroke=\"#0E419D\" stroke-width=\"1.5\" stroke-linecap=\"round\" />\r\n<path d=\"M7.5 10H11\" stroke=\"#0E419D\" stroke-width=\"1.5\" stroke-linecap=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon_result.svg
// module id = iO0k
// module chunks = 16